import DOMPurify from 'dompurify'

/**
 * @param {string} html
 * @param {object} [options]
 * @returns {string}
 */
export const sanitizeHtml = (html, options = {}) => {
  if (!html || typeof html !== 'string') return ''
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'br', 'span'],
    ALLOWED_ATTR: [],
    ...options
  })
}

/**
 * @param {string} svg
 * @param {object} [options]
 * @returns {string}
 */
export const sanitizeSvg = (svg, options = {}) => {
  if (!svg || typeof svg !== 'string') return ''
  return DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true },
    ADD_TAGS: ['use'],
    ADD_ATTR: ['xmlns', 'xmlns:xlink', 'xlink:href'],
    ...options
  })
}

/**
 * @param {string} content
 * @returns {string}
 */
export const sanitizeAll = (content) => {
  if (!content || typeof content !== 'string') return ''
  return DOMPurify.sanitize(content, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
}

export default {
  sanitizeHtml,
  sanitizeSvg,
  sanitizeAll
}
